import React, { memo } from 'react'
import styles from './FirstScreenOfLandingPage.module.scss';
import { useNavigate } from 'react-router-dom';
import { ApplicationRoutes } from '../../../routes';
import { ArrowRight, CurledArrow, PowerIcon, RecommendationIcon, StoreIcon } from '../../../assets/icons';
import WaitListForm from './waitlist-form/waitlistForm';


type Props = {
}

const FirstScreenOfLandingPage: React.FC<Props> = memo((props: Props) => {

    const navigate = useNavigate();

    function navigateToRecommendation() {
        navigate(`/${ApplicationRoutes.RECOMMENDATION}`);
    }

    function navigateToComingSoon() {
        navigate(`/${ApplicationRoutes.COMING_SOON}`);
      }

      function navigateToStore() {
        navigate(`/${ApplicationRoutes.STORE_FRONT}`);
      }

    return (
        <div className={styles.container}>
            <div className={styles.background}>
                <img src="../../../images/landing-background.jpg" />
            </div>

            <div className={styles.content}>
                <div className={styles.title}>
                    The go-to destination for access to affordable
                    <span className={styles.orangeTitle}> solar <CurledArrow className={styles.vector} /></span>
                    solutions
                </div>
                <div>
                    <WaitListForm />
                </div>
                {/* <div className={styles.offer}>
                    <button className={styles.btn} onClick={navigateToRecommendation}>
                        Get Solar Power 
                        <ArrowRight className={styles.arrow} />
                    </button>
                    <div className={styles.description}>
                        At Solar Marketplace, we believe in harnessing the power of the sun to create a brighter, more sustainable future for all.
                    </div>
                </div> */}
            </div>  

            {/* <div className={styles.cards}>
                    <div className={`${styles.card} ${styles.cardBlue}`} onClick={navigateToRecommendation}>
                        <div className={styles.cardIcon}>
                        <PowerIcon />
                        </div>
                        <div className={styles.cardContent}>
                            <div className={styles.cardTitle}>
                                Generate Power Need
                            </div>
                            <div className={styles.cardDescription}>
                              Optimize energy supply for sustainability.
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.card} ${styles.cardRed}`} onClick={navigateToStore}>
                        <div className={styles.cardIcon}>
                            <StoreIcon />
                        </div>
                        <div className={styles.cardContent}>
                            <div className={styles.cardTitle}>
                                Visit Store
                            </div>
                            <div className={styles.cardDescription}>
                                At Solar Marketplace, we believe in harnessing all.
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.card} ${styles.cardGreen}`} onClick={navigateToComingSoon}>
                        <div className={styles.cardIcon}>
                            <RecommendationIcon />
                        </div>
                        <div className={styles.cardContent}>
                            <div className={styles.cardTitle}>
                                View Recommendations
                            </div>
                            <div className={styles.cardDescription}>
                                At Solar Marketplace, we believe in harnessing all.
                            </div>
                        </div>
                    </div>
                </div> */}
        </div>
    )
})

export default FirstScreenOfLandingPage